import React, { useState } from "react";
import CartInputAddress from "../Cart/CartInputAddress";
import CartInputField from "../Cart/CartInputField";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

function AddressForm(props) {
  const [formMail, setFormMail] = useState("");
  const [formNome, setFormNome] = useState("");
  const [formCognome, setFormCognome] = useState("");
  const [formTelefono, setFormTelefono] = useState("");
  const [formAddress, setFormAddress] = useState("");
  const [formCity, setFormCity] = useState("");
  const [formProv, setFormProv] = useState("");
  const [formCap, setFormCap] = useState("");
  const [formPresso, setFormPresso] = useState("");

  const [HasMessage, setHasMessage] = useState(null);
  const [errorList, setErrorList] = useState([]);

  function checkTextValue(txt, fieldName, special = "") {
    if (txt.trim().length === 0)
      //return fieldName + " deve avere valore valido";
      return "Si prega di non lasciare il campo vuoto.";
    if (special === "phone") {
      if (!txt.match(/^[0-9\s(+)-]*$/)) {
        return "Inserire un numero di telefono valido.";
      }
      if (txt.length < 8) {
        return "Numero troppo corto.";
      }
    }

    return "";
  }
  function messageDialog(text) {
    return (
      <Dialog open={true}>
        <DialogContent>
          <p>{text}</p>
          <div className="chiudi_popup_button" onClick={() => closeMessageHandler()}>Chiudi</div>
        </DialogContent>
      </Dialog>
    )
  }

  function closeMessageHandler() {
    setHasMessage(null);
  }

  function validateCart() {
    // step 1: collect all data (done: in state variables)
    // step 2: validate data
    let errorList = [];
    let res = "";

    // 2.1: controlli anagrafica:

    res = checkTextValue(formNome, "Nome");
    if (res !== "") errorList.push({ id: "Nome", msg: res });
    res = checkTextValue(formCognome, "Cognome");
    if (res !== "") errorList.push({ id: "Cognome", msg: res });
    res = checkTextValue(formTelefono, "Telefono", "phone");
    if (res !== "") errorList.push({ id: "Telefono", msg: res });
    res = checkTextValue(formAddress, "Indirizzo");
    if (res !== "") errorList.push({ id: "Address", msg: res });
    res = checkTextValue(formCity, "Città");
    if (res !== "") errorList.push({ id: "City", msg: res });
    res = checkTextValue(formCap, "CAP");
    if (res !== "") errorList.push({ id: "Cap", msg: res });
    res = checkTextValue(formProv, "Provincia");
    if (res !== "") errorList.push({ id: "Province", msg: res });

    return errorList;
  }

  function addAddress() {
    let errorList = validateCart();

    setErrorList(errorList);
    //console.log(errorList);

    if (errorList.length > 0) {
      setHasMessage(
        "La compilazione è incompleta. Segui le indicazioni e riprova!"
      );
      return;
    }
    let params = [
      { name: "id_e_utente", value: props.userData.id_e_user },
      { name: "mail", value: formMail },
      { name: "nome", value: formNome },
      { name: "cognome", value: formCognome },
      { name: "telefono", value: formTelefono },
      { name: "indirizzo", value: formAddress },
      { name: "cap", value: formCap },
      { name: "citta", value: formCity },
      { name: "provincia", value: formProv },
      { name: "nazione", value: "IT" },
      { name: "presso", value: formPresso },
    ];
    props.addAddressHandler(params);
  }

  return (
    <div className={props.cssClass}>
      {HasMessage !== null ? messageDialog(HasMessage) : null}
      <CartInputField
        required={true}
        type="text"
        lbl="Nome"
        name="Nome"
        value={formNome}
        change={setFormNome}
        cssClass="riga_info_cart"
        errList={errorList}
      />
      <CartInputField
        required={true}
        type="text"
        lbl="Cognome"
        name="Cognome"
        value={formCognome}
        change={setFormCognome}
        cssClass="riga_info_cart"
        errList={errorList}
      />
      <CartInputField
        required={false}
        type="text"
        lbl="Presso"
        name="Presso"
        value={formPresso}
        change={setFormPresso}
        cssClass="riga_info_cart"
        errList={errorList}
      />
      <CartInputAddress
        required={true}
        type="text"
        lbl="Indirizzo e numero civico"
        name="Address"
        value={formAddress}
        change={setFormAddress}
        changeCap={setFormCap}
        changeCity={setFormCity}
        changeProv={setFormProv}
        cssClass="riga_info_cart"
        errList={errorList}
        googleMapId={props.cfg.googleMapId}
      />

      <CartInputField
        required={true}
        type="cap"
        lbl="CAP"
        name="Cap"
        value={formCap}
        change={setFormCap}
        cssClass="riga_info_cart"
        errList={errorList}
      />
      <CartInputField
        required={true}
        type="text"
        lbl="Citt&agrave;"
        name="City"
        value={formCity}
        change={setFormCity}
        cssClass="riga_info_cart"
        errList={errorList}
      />
      <CartInputField
        required={true}
        type="text"
        lbl="Provincia"
        name="Address"
        value={formProv}
        change={setFormProv}
        cssClass="riga_info_cart"
        errList={errorList}
      />

      <CartInputField
        required={true}
        type="phone"
        lbl="Telefono"
        name="Telefono"
        value={formTelefono}
        change={setFormTelefono}
        cssClass="riga_info_cart"
        errList={errorList}
      />
      <div className="bottoni_indirizzo_utente">
        <input
          className="aggiungi_indirizzo_utente"
          type="button"
          value="Aggiungi"
          onClick={addAddress}
        />
        <input
          className="chiudi_indirizzo_utente"
          type="button"
          value="Chiudi"
          onClick={() => props.setAddAddress(false)}
        />
      </div>
    </div>
  );
}

export default AddressForm;
